<style lang="scss" scoped>
.trialbar {
    height: 40px;
    background: #333333;
    color: #b2b2b2;
    text-align: center;
    line-height: 40px;
    z-index: 1;
}
</style>

<template>
    <header class="trialbar row" v-if="(workspace.plan_status.status === 2 ||workspace.boards_locked) && workspace.can_edit">
        <div class="col-12">
            <span v-if="workspace.plan_status.status === 2">
                {{ $t('user._index.trial_end') }}
                {{ workspace.plan_status.end_date | moment('from', 'now') }}.
            </span>
            <a href="JavaScript:void(0);" v-if="workspace.can_edit && !$root.isMobile" @click="upgradePlan">
                {{ $t('user._index.upgrade_plan') }}
            </a>
        </div>
    </header>
</template>

<script>
import PaymentUpgradePopup from "@/popups/payment/upgrade";

export default {
    name: 'trial-bar',

    methods: {
        upgradePlan() {
            this.$modal.show(PaymentUpgradePopup, null, { adaptive: true, height: 'auto', width: '900', scrollable: true })
        }
    },

    computed: {
        workspace() {
            return this.$store.getters['workspace/current']
        }
    }
};
</script>
